/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Carriedoutosworkshoponerolemodel7Inputs */

const de__field_carriedoutosworkshoponerolemodel7 = /** @type {(inputs: _Field_Carriedoutosworkshoponerolemodel7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchgeführt OS-Workshop One Role Model`)
};

/**

* @param {_Field_Carriedoutosworkshoponerolemodel7Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_carriedoutosworkshoponerolemodel7 = /** @type {((inputs?: _Field_Carriedoutosworkshoponerolemodel7Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Carriedoutosworkshoponerolemodel7Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_carriedoutosworkshoponerolemodel7(inputs)
});
export { _field_carriedoutosworkshoponerolemodel7 as "_field_carriedOutOSWorkshopOneRoleModel" }